import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=3c3b5838&scoped=true"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3b5838",
  null
  
)

export default component.exports